/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Import_Status_SeatInputs */



/**
* | output |
* | --- |
* | "No seat left" |
*
* @param {Team_Manager_Import_Status_SeatInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_import_status_seat = /** @type {((inputs?: Team_Manager_Import_Status_SeatInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Import_Status_SeatInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Plus de place")
	if (locale === "de") return /** @type {LocalizedString} */ ("Kein Platz frei")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessuna postazione libera")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Нет свободных мест")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sin puestos libres")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("没有剩余席位")
	if (locale === "ja") return /** @type {LocalizedString} */ ("空きシートなし")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कोई सीट खाली नहीं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Sem lugares livres")
	return /** @type {LocalizedString} */ ("No seat left")
});